module.exports = __webpack_public_path__ + "static/media/residentiel-7.f6457cf1.jpg";